import Spinner from '../../../../components/spinner';
import Select from '../../../../components/select';
import {ReactNode} from 'react';
import MultiSelectAutocomplete from '../../../../components/multi-select-autocomplete';

export type Props = {
    label?: string,
    data: Array<any>,
    value: string,
    onChange: (value: string) => void,
    children: [(item: any, i: number) => string, (item: any, i: number) => ReactNode],
    spinner?: boolean,
    disabled?: boolean,
    searchable?: boolean,
    required?: boolean,
    itemToString?: (item: any, i: number) => string,
    enableMultiSelect?: boolean,
    enableFuseSearch?: boolean,
    fuseThreshold?: number,
    fuseKeys?: string[],
    ['data-testid']?: string
};

export default function NOFilter(props: Props) {
    const {label, data, value, onChange, children, spinner, disabled, searchable, required, itemToString, enableMultiSelect, enableFuseSearch = true, fuseThreshold = 0.3, fuseKeys} = props;
    const titleText = (
        <div className='flex flex-row items-center'>
            {label && <label className='block text-gray-500 text-sm mb-1'>{label}</label>}
            {!disabled && spinner && (
                <div className='ml-2' data-testid={props['data-testid'] ? `${props['data-testid']}-spinner` : undefined}>
                    <Spinner />
                </div>
            )}
        </div>
    );

    return (
        <div className='filter-group mb-4'>
            {enableMultiSelect ? (
                <>
                    {/*Putting titleText inside label with class cds--label, fixes its css to align with other filters */}
                    <label className='cds--label'>{titleText}</label>
                    <MultiSelectAutocomplete
                        onChange={(values: string[]) => onChange(values.join('|'))}
                        values={value ? value.split('|') : []}
                        getOptions={() => Promise.resolve(data)}
                        useNewDesign={true}
                        disabled={disabled || spinner}
                        label={label}
                        enableFuseSearch={enableFuseSearch}
                        fuseThreshold={fuseThreshold}
                        {...(props['data-testid'] ? {'data-testid': props['data-testid']} : {})}
                    />
                </>
            ) : (
                <Select
                    key={!value ? 'remount-' + Date.now() : 'normal'}
                    data={data}
                    value={value}
                    onChange={onChange}
                    disabled={disabled || spinner}
                    titleText={titleText}
                    searchable={searchable}
                    required={required}
                    itemToString={itemToString}
                    autoAlign
                    rightAlign
                    enableFuseSearch={enableFuseSearch}
                    fuseThreshold={fuseThreshold}
                    fuseKeys={fuseKeys}
                    {...(props['data-testid'] ? {'data-testid': props['data-testid']} : {})}
                >
                    {children}
                </Select>
            )}
        </div>
    );
}